import type { KeyboardEventHandler } from 'react'

/**
 * A key handler for draft inputs that commit on blur, so Enter commits too.
 *
 * @param commit Commits the draft, like `vm.commitId`.
 */
export function commitOnEnter(
  commit: () => unknown,
): KeyboardEventHandler<HTMLInputElement> {
  return (e) => {
    if (e.key === 'Enter') {
      commit()
    }
  }
}
